<template>
  <div class="flex flex-col gap-[16px] text-[--v3-global-textsecondarycolor]">
    <span class="v3-h5-bold-700-line-height-1.5">{{ title }}</span>
    <div v-if="items.length" class="flex flex-col gap-[12px]">
      <AppLink
        v-for="item in items"
        :key="`menu-footer-${item.title}`"
        :to="item.url"
        class="footer-texts v3-regular-400-line-height-auto"
        @click="emit('select', item)"
      >
        {{ item.title }}
      </AppLink>
    </div>
  </div>
</template>

<script lang="ts" setup>
import AppLink from '@/common/components/atoms/AppLink';

interface Item {
  title: string;
  url: string;
  name: string;
}

defineProps<{
  title: string;
  items: Item[];
}>();

const emit = defineEmits<{
  select: [item: Item];
}>();
</script>
